/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_ZipInputs */

const en_entity_zip = /** @type {(inputs: Entity_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZIP Code`)
};

const de_entity_zip = /** @type {(inputs: Entity_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLZ`)
};

/**
* | output |
* | --- |
* | "ZIP Code" |
*
* @param {Entity_ZipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_zip = /** @type {((inputs?: Entity_ZipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_ZipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_zip(inputs)
	return de_entity_zip(inputs)
});